import { render, staticRenderFns } from "./call-info.vue?vue&type=template&id=71cd817a&scoped=true&"
import script from "./call-info.vue?vue&type=script&lang=js&"
export * from "./call-info.vue?vue&type=script&lang=js&"
import style0 from "./call-info.vue?vue&type=style&index=0&id=71cd817a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cd817a",
  null
  
)

export default component.exports